<template>
  <div id="app">
    <section class="section">
        <div>
            <NameForm  />
        </div>
    </section>

  </div>
</template>

<script>
import NameForm from './components/name.vue'


export default {
  name: 'app',
  components: {
    NameForm
  }
}
</script>

<style>

</style>
